const RouteQueryPlugin = {
    install(Vue, options) {
        Vue.mixin({
            data() {
                return {
                    $RQPluginData: {
                        defaults: {},
                        currentQuery: null,
                        updateInProgress: false,
                        routeReplacedByMe: false
                    },
                }
            },
            computed: {
              propertyGroup() {
                  if(!this.$options.routeQuery) return [];
                  if(!this.$RPOptionsQueryParameters) return [];
                  return this.$RPOptionsQueryParameters.map(x => {
                      return { prop: x, value: this.$data[x] };
                  });
              },    
              $RPOptionsQueryParameters() {
                let cleansed = this.$options.routeQuery.map(x => x.split(':')[0]);
                return cleansed;
              }
            },
            methods: {
                updateRouteQuery(delta) {
                    this.$data.$RQPluginData.updateInProgress = true;
                    for(var prop of _.keys(delta)) {
                        this.$data[prop] = delta[prop];
                    };
                    this.$data.$RQPluginData.updateInProgress = false;
                    this.$RQInvokeRouteQueryUpdate();
                },
                clearRouteQuery() {
                    let config = this.$RPOptionsQueryParameters || [];
                    this.$data.$RQPluginData.updateInProgress = true;
                    for(var prop of config) {
                        this.$data[prop] = this.$data.$RQPluginData.defaults[prop];
                    };
                    this.$data.$RQPluginData.updateInProgress = false;
                    this.$RQInvokeRouteQueryUpdate();
                },
                $RQCaptureDefaultPropertyValues() {
                    let config = this.$RPOptionsQueryParameters || [];
                    for(const prop of config) {
                        this.$data.$RQPluginData.defaults[prop] = _.cloneDeep(this.$data[prop]);
                    }
                },

                $RQIsEnabled() {
                    return this.$options.routeQuery && this.$options.routeQuery.length > 0;
                },

                $RQReplaceRouteQuery(newQuery) {
                    if (this.validateRouteQuery && !this.validateRouteQuery()) return;

                    var prevPath = this.$route.fullPath;

                    this.$router.replace({ query: newQuery });

                    storeInLocalStorage(this.$route, newQuery);

                    if (prevPath != this.$route.fullPath) {
                      this.$RQInvokeRouteQueryUpdate();
                    }
                },
                $RQSetPropertiesFromRoute() {
                    let config = this.$RPOptionsQueryParameters;

                    var updated = false;

                    for(const prop of config) {
                        if (_.isUndefined(this.$data[prop])) throw "Unknown route query property: " + prop;

                        var queryValue = this.$route.query[prop];

                        var propValue = queryValue;
                        if (!_.isUndefined(queryValue)) {
                            if (_.isArray(this.$data[prop]) && !_.isArray(propValue))
                                propValue = [propValue];

                            if (_.isDate(this.$data[prop]) && !_.isDate(propValue))
                                propValue = moment(propValue).format('MM/DD/YYYY');
                        }
                        else
                        {
                            propValue = _.cloneDeep(this.$data.$RQPluginData.defaults[prop]);
                        }

                        if (!valuesEqual(this.$data[prop], propValue)) {
                            this.$data[prop] = propValue;
                            updated = true;
                        }
                    }

                    this.$data.$RQPluginData.currentFullPath = this.$route.fullPath;
                },

                $RQInvokeRouteQueryUpdate() {
                    if (!this.onRouteQueryUpdate) throw "Method onRouteQueryUpdate must be defined";
                    if (this.$data.$RQPluginData.updateInProgress) return;
                    this.onRouteQueryUpdate();
                },
                $RQRestoreRouteFromLocalStorage() {
                    var storedItem = localStorage.getItem("rq-" + this.$route.path);
                    if (!storedItem) return;
                    var stored = JSON.parse(storedItem);
                    if (!stored.query) return;

                    for(var prop of _.keys(stored.query)) {
                        if (this.$RPOptionsQueryParameters.includes(prop))
                            this.$data[prop] = stored.query[prop];
                        else
                            delete stored.query[prop];
                    };
                    this.$router.replace({ query: stored.query });
                    this.$data.$RQPluginData.routeReplacedByMe = true;
                },
                $RQDetermineIfUpdateIsNeeded(oldQuery, newQuery) {
                  let ignoredPropertiesChanged = false;
                  let nonIgnoredPropertiesChanged = false;
                  let ignoredProps = this.$options.routeQuery
                                      .filter(x => x.includes('ignoreUpdates'))
                                      .map(x => x.split(':')[0]);
                  for(let i of ignoredProps) {
                    if (oldQuery[i] != newQuery[i]) {
                      ignoredPropertiesChanged = true;
                    }
                  }

                  for(let i of this.$options.routeQuery.filter(x => !x.includes('ignoreUpdates'))) {
                    if (oldQuery[i] != newQuery[i]) {
                      nonIgnoredPropertiesChanged = true;
                    }
                  }

                  return !ignoredPropertiesChanged && nonIgnoredPropertiesChanged;
                }

            },
            created() {
                if (!this.$RQIsEnabled()) return;
                this.$RQCaptureDefaultPropertyValues();
                if (_.keys(this.$route.query).length > 0) {
                    this.$RQSetPropertiesFromRoute();
                } else {
                    this.$RQRestoreRouteFromLocalStorage();
                }
            },
            watch: {
                propertyGroup: {
                    immediate: false,
                    deep: true,
                    handler(newVal) {
                        if(!newVal.length) return;
                        var newQuery = _.cloneDeep(this.$route.query);
                        for(var obj of newVal) {
                            var prop = obj.prop;
                            var val = obj.value;

                            if(_.isDate(val)) {
                                val = moment(val).format('MM/DD/YYYY');
                            }

                            if(!valuesEqual(val, this.$data.$RQPluginData.defaults[prop]))
                                newQuery[prop] = _.cloneDeep(val);
                            else
                                delete newQuery[prop];                                
                        }
                        this.$RQReplaceRouteQuery(newQuery);
                    }
                },
                "$route.query": {
                    handler(newVal, oldVal) {
                        if (!this.$RQIsEnabled()) return;
                        if (this.$data.$RQPluginData.currentFullPath == this.$route.fullPath) return;
                        if (this.$data.$RQPluginData.routeReplacedByMe) {
                            this.$data.$RQPluginData.routeReplacedByMe = false;
                            return;
                        }

                        this.$RQSetPropertiesFromRoute();
                        if (this.$RQDetermineIfUpdateIsNeeded(oldVal, newVal)) {
                          this.$RQInvokeRouteQueryUpdate();
                        }
                    }
                },
                deep: false,
                immediate: false
            }
        })
    }
}

function valuesEqual(val1, val2) {
    return JSON.stringify(val1) == JSON.stringify(val2);
}


function storeInLocalStorage(route, routeQuery) {
    var key = "rq-" + route.path;
    if (_.keys(routeQuery).length == 0)
        localStorage.removeItem(key);
    else
        localStorage.setItem(key, JSON.stringify({
            query: routeQuery,
            updatedAt: new Date().getTime()
        }));
}

function removeExpiredItemsFromLocalStorage() {
    var keys = _.keys(localStorage);
    for(var key of keys) {
        if (key.startsWith("rq-")) {
            var obj = JSON.parse(localStorage.getItem(key));
            if (obj.updatedAt && moment(new Date()).diff(moment(obj.updatedAt), "days") > 1) {
                localStorage.removeItem(key);
            }
        }
        if (key.startsWith("amf:persist")) localStorage.removeItem(key);
    }
}

setInterval(removeExpiredItemsFromLocalStorage, 30 * 60 * 1000);

export { RouteQueryPlugin }



// WEBPACK FOOTER //
// ./src/framework/utils/route-query-plugin.js